// WelcomePopup.jsx
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { X, QrCode, MapPin, Camera, Award } from "lucide-react";

export default function WelcomePopup({ user, onClose }) {
  const closeBtnRef = useRef(null);

  useEffect(() => {
    closeBtnRef.current?.focus();
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return createPortal(
    <div
      className="welcome-popup-overlay"
      onClick={onClose}
      role="presentation"
      aria-hidden={false}
    >
      <div
        className="welcome-popup"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Welcome to BinBuddy"
      >
        {/* Close button is absolute inside popup */}
        <button
          onClick={onClose}
          className="close-btn"
          aria-label="Close welcome popup"
          ref={closeBtnRef}
        >
          <X size={18} />
        </button>

        {/* Title at the top */}
        <header className="welcome-header">
          <h2 className="welcome-title">Welcome to BinBuddy, {user?.name || "User"}! 🎉</h2>
        </header>

        {/* Scrollable content area */}
        <div className="welcome-content">
          <p className="welcome-intro">
            We're excited to have you join our community of environmental champions!
          </p>

          <div className="feature-highlights">
            <div className="feature-item">
              <QrCode size={20} />
              <span>Scan QR codes on bins</span>
            </div>

            <div className="feature-item">
              <MapPin size={20} />
              <span>Find nearby bins</span>
            </div>

            <div className="feature-item">
              <Camera size={20} />
              <span>Quick photo capture for issues</span>
            </div>

            <div className="feature-item">
              <Award size={20} />
              <span>Earn points and redeem rewards</span>
            </div>
          </div>

          <p className="welcome-tip">
            💡 <strong>Quick Tip:</strong> Start by exploring the Quick Actions below!
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
}
